import { Typography } from "@cur8/maneki";
import { useConfig } from "render/context/ConfigContext";
import styles from "./styles.module.sass";

const PR_HOST_SUFFIX = ".concierge.pr.dev.cur8.co";

/**
 * config.dev.json is served to localhost, the dev deploy and every PR deploy
 * alike, so the config alone cannot tell them apart. The host can: a PR
 * build's namespace prefix is the one in its deployment comment.
 */
export function environmentLabel(hostname: string) {
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "Local";
  }

  if (hostname.endsWith(PR_HOST_SUFFIX)) {
    return `Feature branch ${hostname.slice(0, -PR_HOST_SUFFIX.length)}`;
  }

  return "Dev";
}

/**
 * Shown wherever config.dev.json is served: localhost, the dev deploy and PR
 * branch deploys. Preprod and prod both serve config.prod.json, so neither
 * renders this.
 */
export function EnvironmentBanner() {
  const { stageType } = useConfig();

  if (stageType !== "development") {
    return null;
  }

  return (
    <div className={styles.EnvironmentBanner}>
      {/* eyebrow-s uppercases in CSS, so the text node stays sentence case. */}
      <Typography as="span" variant="eyebrow-s">
        {environmentLabel(window.location.hostname)}, test environment
      </Typography>
    </div>
  );
}
